import React from "react";
import UploadIcon from "./UploadIcon";

export default function UploadCard({ userType, onClick, hex }) {
  return (
    <div
      className="featured-content__wrapper"
      onClick={() => onClick(userType)}
    >
      <div className="featured-content__panel">
        <div className="featured-content__panel-content">
          <h4 className="featured-content__panel-title">File upload</h4>
          <UploadIcon hex={hex} />
          <p className="featured-content__text">Click here to select a file</p>
          <p className="featured-content__limit">Maximum file size is 140MB.</p>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/FeaturedContent/components/UploadCard.jsx